import { render } from "./TechStack.vue?vue&type=template&id=358c9a30&scoped=true"
import script from "./TechStack.vue?vue&type=script&lang=js"
export * from "./TechStack.vue?vue&type=script&lang=js"

import "./TechStack.vue?vue&type=style&index=0&id=358c9a30&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358c9a30"]])

export default __exports__